// Balances for the ledger-based reports (Ledger, Cash Book, Bank Book, Ledger
// Group). Api/Reports/LedgerReport/GetAll returns
//   ledgerReportDetails: one row per voucher line of a ledger - its own
//     debit / credit, `group` = the ledger's own group, `ledgerID`,
//     `ledgerName`, `balance` + `isDebitBalance` = that ledger's running balance
//   ledgerSummaries: one row per ledger - openingBalance / isDebitOB, debit,
//     credit, closingBalance / isDebitCB
// Balances come as a positive amount plus a debit flag; here they are signed
// (debit +, credit -) so they can be added up.

const num = (v) => Number(v) || 0;

export const signed = (amount, isDebit) => (isDebit ? 1 : -1) * num(amount);

// "1,250.00 Dr" / "80.00 Cr"; a zero balance has no side
export const drCr = (value, decimals = 2) => {
  const v = num(value);
  const text = Math.abs(v).toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  if (Math.abs(v) < 0.005) return text;
  return `${text} ${v < 0 ? "Cr" : "Dr"}`;
};

// opening and closing of the ledgers that pass `keep` (e.g. one group)
export const summaryTotals = (summaries, keep = () => true) =>
  (Array.isArray(summaries) ? summaries : []).filter(keep).reduce(
    (t, s) => ({
      opening: t.opening + signed(s.openingBalance, s.isDebitOB),
      debit: t.debit + num(s.debit),
      credit: t.credit + num(s.credit),
      closing: t.closing + signed(s.closingBalance, s.isDebitCB),
    }),
    { opening: 0, debit: 0, credit: 0, closing: 0 }
  );

// rows (in the server's date order) with the running balance of the book
// they make up together, starting from `opening`
export const withRunningBalance = (rows, opening, decimals = 2) => {
  let running = opening;
  return (Array.isArray(rows) ? rows : []).map((r) => {
    running += num(r.debit) - num(r.credit);
    return { ...r, runningBalance: running, balanceText: drCr(running, decimals) };
  });
};
